<mat-card>
  <mat-card-header>
    <mat-card-title> <h2>Access Reporting Services</h2> </mat-card-title>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <a
      mat-raised-button
      href="https://analytics.gmr.net/Reports/browse/Flight%20Crew%20Reports"
      target="_blank"
      mat-color="primary"
      >Go</a
    >
    <p>
      *Note: This link is external to FlightLog. When asked for your credentials, please provide
      your Username in the format of emsc\username (username is usually in firstName.lastName or
      firstName.middleInitial.lastName format).
    </p>
  </mat-card-content>
</mat-card>
